import { useQuery } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';

export type BudgetProposalEdition = {
    canAddInscription: boolean;
    canAddInscriptionInPhase: boolean;
    isEditionOpenToResource: boolean;
};

export const useGetBudgetProposalEdition = (
    budgetProposalId: number,
    resourceSoftwareId: string,
) =>
    useQuery({
        queryKey: [
            'budgetProposalEdition',
            budgetProposalId,
            resourceSoftwareId,
        ],

        queryFn: async () => {
            const response = await RQAPICallWithData<BudgetProposalEdition>({
                endpoint: `budget_proposals/edition/${budgetProposalId}/resource/${resourceSoftwareId}`,
                method: 'GET',
            });
            return response.content.data;
        },
    });
